<template>
    <div class="site-panel" style="border-bottom-style: solid; border-bottom-width: 1px; border-radius: 0; height: 855px;">
        <v-row class="no-frame">
            <v-col class="main-first-col modal-tab no-border ma-0 mr-1">
                <v-row class="no-frame pt-2 w-100">
                    <c-recipient-card-iterator
                        class="w-100"
                        title        = "Empfänger des Kunden"
                        :recipients  = "items"
                        :customer-id = "site.customer.id"
                        :lim         = "false"
                        :inc         = "true"
                        :filter      = "this.filter"
                        :enable-zoom ="false"
                        :left-arrow  = "false"
                        :show-main-type-filter="false"
                        :height      = "800"
                        highlight-color="lightgray"
                    />
                </v-row>
            </v-col>
            <v-col class="main-middlle-col recipient-col modal-tab no-border ma-0 mr-1">
                <v-row class="no-frame">
                    <c-site-recipients-column
                        title           = "Rechnungsempfänger für Anlage"
                        accept-property = "invoice"
                        @assign         = "onAssign"
                        @remove         = "onRemove"
                        :recipients     = "selected.invoice"
                        :separated      = "separated"
                    />
                </v-row>
            </v-col>
            <v-col class="main-middlle-col recipient-col modal-tab no-border ma-0 mr-1">
                <v-row class="no-frame">
                    <c-site-recipients-column
                        title           = "Leistungsemfänger/Verwender für Anlage"
                        accept-property = "benefit"
                        @assign         = "onAssign"
                        @remove         = "onRemove"
                        :recipients     = "selected.benefit"
                        :separated      = "separated"
                    />
                </v-row>
            </v-col>
            <v-col class="main-last-col recipient-col modal-tab no-border ma-0">
                <v-row class="no-frame">
                    <div class="w-100 background-aliceblue" >
                    </div>
                </v-row>
            </v-col>
        </v-row>
    </div>
</template>

<script>

import Site                    from "@/modules/msd/unit/service/Site";
import CSiteRecipientsColumn   from "@/modules/msd/unit/components/dialog/CSiteRecipientsColumn";
import CRecipientCardIterator  from "@/modules/msd/company/recipient/components/CRecipientCardIterator";

export default {
    name: "TSiteRecipients",
    components: {
        CRecipientCardIterator,
        CSiteRecipientsColumn,
    },

    props: {
        site: {
            required: true,
            type    : Object,
            default : function () {
                return {
                    customer: {
                        recipientsSeparated: false,
                    },
                    recipients: {
                        selected : [],
                        availible: [],
                    }
                }
            }
        },
    },

    data: () => ({
        all: [],
        selected: {
            benefit: [],
            invoice: [],
            forward: []
        },
        assigned: [],
        separated: false,
        filter  : {
            text           : "",
            lim            : false,
            inc            : false,
            benefit        : true,
            invoice        : true,
            usedOnIncidents: false,
            usedOnRepair   : false,
            usedOnCosts    : false

        },
        TYPE: Site.RECIPIENT.TYPE,
    }),

    mounted() {
        this.all               = this.site.recipients.all;
        this.selected.invoice  = this.site.recipients.invoice;
        this.selected.benefit  = this.site.recipients.benefit;
        this.selected.forward  = this.site.recipients.forward;
        this.separated         = this.site.customer.recipientsSeparated;
    },

    watch: {
    },

    computed: {
        items () {
            return this.all.filter (r => r.incidentmanagement);
        },
    },

    methods: {
        onEdit (recipient) {
            this.selected = recipient;
            this.edit = true;
        },

        onAssign (event) {
            if (this.isAssigned(event)) {
                return;
            }

            const list = this.list(event.type);
            list.push(event);
            this.store();
        },

        onRemove (event) {
            const list  = this.list(event.type);
            const index = list.findIndex(r => r.recipient.id === event.recipient.id && r.usage === event.usage);
            if (index >= 0) {
                list.splice(index, 1);
            }

            this.store();
        },

        onAcceptData (recipient) {
            return !this.items.some(r => r.id === recipient.id)
        },

        isAssigned (event) {
            return this.list(event.type).some(r => r.recipient.id === event.recipient.id && r.usage === event.usage);
        },

        store () {
            Site.storeRecipients(this.site.id, {
                benefit: this.selected.benefit,
                invoice: this.selected.invoice,
                forward: this.selected.forward,
            }, () => {
                console.log("stored")
            });
        },

        /**
         * Return the list of selected recipients for the given type.
         *
         * @param type the requested type.
         * @returns the list of selected recipients for the given type.
         */
        list (type) {
            switch (type) {
                case this.TYPE.BENEFIT:
                    return this.selected.benefit;
                case this.TYPE.INVOICE:
                    return this.selected.invoice;
                case this.TYPE.FORWARD:
                    return this.selected.forward;
            }

            return [];
        }
    }
}
</script>

<style scoped>

.recipient-col {
    height: 854px!important;
    max-height: 854px!important;
}

</style>